<template>
    <section class="padding-vertical-content lightgray-content mb-3 mb-lg-4" id="paso-1">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="d-flex align-items-center">
                        <div>
                            <h1 class="text-uppercase">{{ $t('bases.datos_deportista') }}</h1>
                        </div>
                        <div v-if="manager.documentacion_obligatoria_bases && !esRenovacion" class="ml-3">
                            <b-btn @click="show_modal = true">{{ $t('bases.informacion_importante') }}</b-btn>
                            <b-modal
                                size="xl"
                                centered
                                :hide-footer="true"
                                v-model="show_modal"
                                title="Información importante"
                            >
                                <b-row>
                                    <b-col cols="12" class="text-justify">
                                        <p>{{ $t('bases.texto_documentacion_1') }}</p>
                                        <p>{{ $t('bases.texto_documentacion_2') }}</p>
                                        <p>{{ $t('bases.texto_documentacion_3') }}</p>

                                        <b><p>- {{ $t('bases.dni_jugador') }}</p></b>
                                        <b><p>- {{ $t('bases.dni_responsables') }}</p></b>
                                    </b-col>
                                </b-row>
                            </b-modal>
                        </div>
                    </div>
                    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                        <div class="padding-content white-content mb-2">
                            <b-card v-if="error === 'no'" bg-variant="success" title="Éxito" class="mb-4">
                                <b-card-text>
                                    {{ $t('bases.exito') }}
                                </b-card-text>
                            </b-card>
                            <b-card v-if="error === 'si'" bg-variant="danger" title="Fallo">
                                <b-card-text>
                                    {{ $t('bases.error') }}
                                </b-card-text>
                            </b-card>
                            <div class="row">
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <label for="nombre">{{$t("formularios.nombre") + " *"}}</label>
                                        <ValidationProvider name="nombre" rules="required" v-slot="{ errors }">
                                            <input id="nombre" type="text" :class="
                                                'form-control ' + (errors[0] ? 'is-invalid' : '')
                                            " :placeholder="$t('formularios.nombre')" v-model="base.nombre" :disabled="!paso_activo"/>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <label for="apellidos">{{$t("formularios.apellidos") + " *"}}</label>
                                        <ValidationProvider name="apellidos" rules="required" v-slot="{ errors }">
                                            <input id="apellidos" type="text" :class="
                                                'form-control ' + (errors[0] ? 'is-invalid' : '')
                                            " :placeholder="$t('formularios.apellidos')" v-model="base.apellidos" :disabled="!paso_activo"/>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <label for="dni">{{ $t("formularios.dni") + " *" }}</label>
                                        <ValidationProvider name="dni" rules="required" v-slot="{ errors }">
                                            <input id="dni" type="text" :class="
                                                'form-control ' + (errors[0] ? 'is-invalid' : '')
                                            " :placeholder="$t('formularios.dni')" v-model="base.dni" :disabled="!paso_activo"/>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <label for="fecha_nacimiento">{{$t("formularios.nacimiento") + " *"}}</label>
                                        <ValidationProvider name="fecha_nacimiento" rules="required"
                                            v-slot="{ errors }">
                                            <input id="fecha_nacimiento"  min="1900-01-01" max="2999-12-31" type="date" :class="
                                                'form-control ' + (errors[0] ? 'is-invalid' : '')
                                            " :placeholder="$t('formularios.nacimiento')" v-model="base.fecha_de_nacimiento" :disabled="!paso_activo"/>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <label for="fecha_caducidad_dni">{{ $t('bases.fecha_caducidad_dni') }} *</label>
                                        <ValidationProvider name="fecha_caducidad_dni" rules="required"
                                            v-slot="{ errors }">
                                            <input id="fecha_caducidad_dni" min="1900-01-01" max="2999-12-31" type="date" :class="
                                                'form-control ' + (errors[0] ? 'is-invalid' : '')
                                            " v-model="base.fecha_de_caducidad_dni" :disabled="!paso_activo"/>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <label for="telefono">{{$t("formularios.telefono") + " *"}}</label>
                                        <ValidationProvider name="telefono" rules="required|numeric" v-slot="{ errors }">
                                            <input id="telefono" type="number" :class="
                                                'form-control ' + (errors[0] ? 'is-invalid' : '')
                                            " :placeholder="$t('formularios.telefono')" v-model="base.telefono" :disabled="!paso_activo"/>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <label for="email">{{$t("formularios.email") + " *"}}</label>
                                        <ValidationProvider name="email" rules="required" v-slot="{ errors }">
                                            <input id="email" type="email" :class="
                                                'form-control ' + (errors[0] ? 'is-invalid' : '')
                                            " :placeholder="$t('formularios.email')" v-model="base.email" :disabled="!paso_activo"/>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <Paises id="pais_de_nacimiento" :desactivar="!paso_activo ? true : false" :errors="errors" @rellenarPais="rellenarPais" v-on:selected="
                                            (opt) => {
                                                pais = opt;
                                                base.pais_de_nacimiento = opt.id;
                                            }
                                        " />
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <Provincias id="provincia_de_nacimiento" :desactivar="!paso_activo ? true : false" :errors="errors" :pais="pais.id" :provincia="provincia"
                                            v-on:selected="
                                                (opt) => {
                                                    provincia = opt;
                                                    base.provincia_de_nacimiento = opt.id;
                                                }
                                            " />
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <Locations id="localidad_de_nacimiento" :desactivar="!paso_activo ? true : false" :provincia="provincia" :location_id="base.localidad_de_nacimiento" :errors="errors"
                                            v-on:selected="
                                                (opt) => {
                                                    base.localidad_de_nacimiento = opt.id;
                                                }
                                            " />
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <label for="nacionalidad">{{$t("formularios.nacionalidad") + " *"}}</label>
                                        <ValidationProvider name="nacionalidad" rules="required" v-slot="{ errors }">
                                            <input id="nacionalidad" type="text" :class="
                                                'form-control ' + (errors[0] ? 'is-invalid' : '')
                                            " :placeholder="$t('formularios.nacionalidad')" v-model="base.nacionalidad" :disabled="!paso_activo"/>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <label for="direccion">{{$t("formularios.domicilio") + " *"}}</label>
                                        <ValidationProvider name="direccion" rules="required" v-slot="{ errors }">
                                            <input id="direccion" type="text" :class="
                                                'form-control ' + (errors[0] ? 'is-invalid' : '')
                                            " :placeholder="$t('formularios.domicilio')" v-model="base.direccion" :disabled="!paso_activo"/>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div v-if="categorias_bases" class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <label>{{ $t('bases.cuota') }} *</label>
                                        <ValidationProvider name="categoria_base" rules="required" v-slot="{ errors }">
                                            <multiselect 
                                                v-model="base.categoria_base"
                                                :class="errors[0] ? 'is-invalid' : ''" 
                                                placeholder="Categoría Base"
                                                label="name"
                                                track-by="id" 
                                                :multiple="false" 
                                                :options="categorias_bases"
                                                v-on:select="
                                                    (selectedOpt) => $emit('selected', selectedOpt)
                                                "
                                                :disabled="!paso_activo">
                                                    <template slot="option" slot-scope="props">
                                                        <div class="option__desc"><span class="option__title">{{ props.option.name }}</span> - <span class="option__small">{{ props.option.precio | formatear_precio }}</span></div>
                                                    </template>
                                                </multiselect>
                                            <span v-if="errors[0]" class="error invalid-feedback"
                                                style="display: block">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div v-if="equipos" class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <label>{{ $t('bases.equipo') }} *</label>
                                        <ValidationProvider name="equipo" rules="required" v-slot="{ errors }">
                                            <multiselect 
                                                v-model="base.equipo"
                                                :class="errors[0] ? 'is-invalid' : ''" 
                                                placeholder="Equipo"
                                                label="nombre"
                                                track-by="id" 
                                                :multiple="false" 
                                                :options="equipos"
                                                :disabled="!paso_activo">
                                            </multiselect>
                                            <span v-if="errors[0]" class="error invalid-feedback" style="display: block">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <label>{{ $t('bases.lateralidad') }} *</label>
                                        <ValidationProvider name="lateralidad" id="lateralidad" rules="required" v-slot="{ errors }">
                                            <multiselect 
                                                v-model="base.lateralidad"
                                                :class="(errors[0] ? 'is-invalid' : '')"
                                                placeholder="Lateralidad"
                                                id="lateralidad"
                                                :multiple="false" 
                                                :options="lateralidades"
                                                v-on:select="
                                                    (selectedOpt) => $emit('selected', selectedOpt)
                                                "
                                                :disabled="!paso_activo">
                                            </multiselect>
                                            <span v-if="errors[0]" class="error invalid-feedback"
                                                style="display: block">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <label for="club_de_procedencia">{{ $t('bases.club_procedencia') }}</label>
                                        <ValidationProvider name="club_de_procedencia">
                                            <input id="club_de_procedencia" type="text" class="form-control"
                                                placeholder="Club de procedencia" v-model="base.club_de_procedencia" :disabled="!paso_activo"/>
                                        </ValidationProvider>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mt-4">
                            <button type="submit" name="button" :class="!esMovil ? 'button effect-button large-button' : 'button effect-button'" id="terminar-paso-1" :disabled="!paso_activo">
                                <span>{{ $t('formularios.continuar') }}</span>
                            </button>
                            <button @click="volver" name="button" :class="!esMovil ? 'button effect-button large-button ml-2' : 'button effect-button ml-2'" id="volver-paso-1" :disabled="!paso_activo" >
                                <span>{{ $t('formularios.atras') }}</span>
                            </button>
                        </div>
                    </ValidationObserver>
                </div>
            </div>
        </div>
    </section>    
</template>

<script>
import Provincias from "../../common/forms/Provincias.vue";
import Locations from "../../common/forms/Locations.vue";
import Paises from "../../common/forms/Paises.vue";

export default {
    props: ["base", "codigo_invitacion", "paso_activo", "esMovil"],
    data() {
        return {
            errors: [],
            error: this.$route.query.error,
            provincia: null,
            pais: { id: 0 },
            nacionalidad: "Española",
            selected: null,
            items: null,
            categorias_bases: [],
            lateralidades: ['Diestro', 'Zurdo', 'Ambidiestro'],
            show_modal: false,
            esRenovacion: window.location.href.indexOf("renovar") > -1,
            equipos: null,
        };
    },
    created() {
        if (!this.manager.activar_compra_por_invitacion_bases) {
            let parametros = {
                lista_id: this.lista_id,
                filters: {
                    tid: this.configuracion.hash_teatro
                }
            }
            this.$store.dispatch(this.config.getVuexAlias("back.categorias.bases"), parametros).then(res => {
                this.categorias_bases = res.data.data;
                if (this.categorias_bases && this.categorias_bases.length == 1) {
                    this.base.categoria_base = this.categorias_bases[0];
                }
            });
        } else {
            let params = {
                filters: {
                    codigo_invitacion: this.codigo_invitacion
                }
            }
            this.$store.dispatch(this.config.getVuexAlias('front.bases.codigo.get-categoria'), params).then(res => {
                this.categorias_bases = [res.data.categoria];
            });
        }

        this.getEquipos();

        if (!this.base.provincia_de_nacimiento) {
            this.provincia = this.teatro.provincia;
        } else {
            this.provincia = this.base.provincia_de_nacimiento;
        }
    },
    methods: {
        categoria_cambiada() {
            this.items = [
                {
                    titulo: this.categorias_bases[this.base["categoria_base"]]["label"],
                    descripcion: null,
                    precio: this.categorias_bases[this.base["categoria_base"]]["precio"],
                },
            ];
        },
        terminar() {
            let params = {
                base: this.base,
                filters: {
                    tid: this.configuracion.hash_teatro,
                }
            }
            this.base['teatro_id'] = this.teatro.id;
            this.base['metodo_pago'] = 5;
            this.base['taquilla'] = 0;
            this.base['codigo_invitacion'] = this.codigo_invitacion;
            this.base['equipo_id'] = this.base['equipo'] ? this.base['equipo']['id'] : null;

            if (typeof this.base['provincia_de_nacimiento'] == 'object' && typeof this.base['localidad_de_nacimiento'] == 'object') {
                this.base['provincia_de_nacimiento'] = this.base['provincia_de_nacimiento']['id'];
                this.base['localidad_de_nacimiento'] = this.base['localidad_de_nacimiento']['id'];
            }

            this.base['descuento_integro'] = 0;
            this.base['descuento_aplicado'] = 0;

            this.$store.dispatch(this.config.getVuexAlias('front.bases.guardar-datos-deportista'), params).then(res => {
                this.base.session_id = res.data.session_id;
                this.base.jet_id = res.data.jet_id;
            });
            this.$emit("terminado");
        },
        rellenarPais(pais) {
            this.base.pais_de_nacimiento = pais.nombre;
        },
        volver() {
            this.$emit('volver');
        },
        async submit() {
            const isValid = await this.$refs.observer.validate();
            if(isValid) {
                this.terminar();
            }
        },
        getEquipos() {
            let params = {
                filters: {
                    teatro_id: this.teatro.id
                }
            }

            this.$store.dispatch(this.config.getVuexAlias("front.bases.equipos"), params).then(res => {
                this.equipos = res.data.data;
            });
        }
    },
    computed: {
        teatro() {
            return this.$store.getters.getTeatro;
        },
        manager() {
            return this.$store.getters.getFooter;
        },
        configuracion() {
            return this.$store.getters.getConfig;
        },
        lista_id() {
            return this.$route.params.lista_id;
        }
    },
    components: { Paises, Locations, Provincias },
};
</script>